import { motion } from 'framer-motion';
import { MessageSquare } from 'lucide-react';

export type BalloonPoint = { x: number; y: number };
export type BalloonVariant = 'professional' | 'patient';

type TransitionTextBalloonProps = {
	id: number;
	from: BalloonPoint;
	to: BalloonPoint;
	durationMs: number;
	variant: BalloonVariant;
	onArrive: (id: number) => void;
};

const BALLOON_SIZE = 42;
const HALF = BALLOON_SIZE / 2;

/** Azul = profissional · Roxo = paciente. */
const VARIANT_STYLE: Record<BalloonVariant, { bg: string; shadow: string }> = {
	professional: {
		bg: '#8ab4f8',
		shadow: '0 8px 20px -4px rgba(138,180,248,0.75)',
	},
	patient: {
		bg: '#b89cf6',
		shadow: '0 8px 20px -4px rgba(184,156,246,0.75)',
	},
};

/**
 * Balão de texto único que viaja da câmera (esquerda) até a folha (direita).
 * Ao concluir o trajeto dispara `onArrive`, momento em que o orquestrador
 * acrescenta linhas à folha.
 */
const TransitionTextBalloon = ({
	id,
	from,
	to,
	durationMs,
	variant,
	onArrive,
}: TransitionTextBalloonProps) => {
	const style = VARIANT_STYLE[variant];

	return (
		<motion.div
			className="pointer-events-none absolute left-0 top-0 flex items-center justify-center rounded-full text-[#0f1722]"
			style={{
				width: BALLOON_SIZE,
				height: BALLOON_SIZE,
				backgroundColor: style.bg,
				boxShadow: style.shadow,
			}}
			initial={{
				x: from.x - HALF,
				y: from.y - HALF,
				opacity: 0,
				scale: 0.35,
			}}
			animate={{
				x: to.x - HALF,
				y: to.y - HALF,
				opacity: [0, 1, 1, 0],
				scale: [0.35, 1, 1, 0.6],
			}}
			transition={{
				duration: durationMs / 1000,
				ease: 'easeInOut',
				times: [0, 0.25, 0.8, 1],
			}}
			onAnimationComplete={() => onArrive(id)}
		>
			<MessageSquare size={22} strokeWidth={2.3} />
		</motion.div>
	);
};

export { TransitionTextBalloon };
